<template>
    <modal v-model="showModal" @hidden="onHide" size="small">
        <template slot="header">
            <div>
                <h2 class="display-4 montserrat-bold mt-4 mb-0">Change password</h2>
                <div class="mt--2 heading-small">Secure your account with your password</div>
            </div>
        </template>
        <form @submit.prevent="save" class="row">
            <div class="col-lg-12">
                <form-input
                    placeholder="Current password"
                    label="Current password"
                    v-model="form.current_password"
                    type="password"
                    ref="current_password"
                ></form-input>
            </div>
            <div class="col-lg-12">
                <form-input
                    placeholder="New password"
                    label="New password"
                    v-model="form.password"
                    type="password"
                    ref="password"
                ></form-input>
            </div>
            <div class="col-lg-12">
                <form-input
                    placeholder="Confirm password"
                    label="Confirm password"
                    v-model="form.password_confirmation"
                    type="password"
                    ref="password_confirmation"
                ></form-input>
            </div>
            <div class="col-lg-12">
                <button v-if="!isRequesting" type="submit" class="btn btn-warning long float-right">
                    <i class="fa fa-save mr-1"></i> Save
                </button>
                <button v-else disabled class="disabled btn btn-warning long float-right">
                    <i class="fa fa-spinner fa-spin mr-2"></i> Please wait
                </button>
            </div>
        </form>
    </modal>
</template>
<script>
import mixins from '@utils/mixins';
import Form from '@models/components/Form';

export default {
    name: 'ChangePasswordForm',

    data: () => ({
        isRequesting: false,
        showModal: false,
        clearModal: true,
        form: new Form({
            current_password: "",
            password: "",
            password_confirmation: "",
        })
    }),

    methods: {
        clearFields(includeErrors = true) {
            this.form.reset();

            if (includeErrors) {
                this.$refs.current_password ? this.$refs.current_password.clearError() : "";
                this.$refs.password.clearError();
                this.$refs.password_confirmation.clearError();
            }
        },

        show() {
            this.showModal = true;
        },

        onHide() {
            this.showModal = false;
            if (this.clearModal) {
                this.clearFields();
            }
        },

        async save() {
            this.clearModal = this.showModal = false;
            if (!(await this.confirm("Are you sure you want to update this data?", "")).value) {
                this.showModal = true;
                return;
            }
            this.isRequesting = this.clearModal = this.showModal = true;
            this.$store.dispatch("updatePassword", { data: this.form.getData() })
                .then(response => this.saved(response))
                .catch(error => this.saveFailed(error))
                .finally(() => (this.isRequesting = false));
        },

        saved(response) {
            this.promptSuccess(response.data.message);
            this.onHide();
        },

        saveFailed(error) {
            this.clearFields(false);
            this.promptFormErrors(this.$refs, error);
        },
    },

    mixins: [ mixins ],

    mounted() {
        this.form.save();
    }
}
</script>